// ════════════════════════════════════════════════════════════════════════
//  When may a version be published?
//
//  Publishing is irreversible: from that moment the bundle is immutable and
//  classes hang off it. Two things therefore have to be true — no open problems,
//  and nothing unsaved. Both reasons need to be visible on the button, otherwise
//  a disabled button is a dead end.
// ════════════════════════════════════════════════════════════════════════

export type PublishGate = {
  readonly allowed: boolean;
  /** Button caption — names the reason when publishing is blocked. */
  readonly label: string;
  /** Tooltip, one sentence on what to do next. */
  readonly title: string;
};

export function publishGate(problemCount: number, dirty: boolean): PublishGate {
  if (problemCount > 0) {
    return {
      allowed: false,
      label: problemCount === 1 ? "1 Hinweis offen" : `${problemCount} Hinweise offen`,
      title: "Erst die Hinweise beheben",
    };
  }
  if (dirty) {
    return { allowed: false, label: "Erst speichern", title: "Erst speichern" };
  }
  return {
    allowed: true,
    label: "Veröffentlichen",
    title: "Fassung unveränderlich machen",
  };
}
